import { DiagramLineEdge } from './DiagramLineEdge';
import { DiagramTileNode } from './DiagramTileNode';

/*
 * React Flow renders the nodes and edges again when these objects change, so
 * they are module constants.
 */

/**
 * The node components of the builder canvas, by React Flow node type. The
 * builder tiles have connection handles. The other node types are shared.
 */
export const NODE_TYPES = { tile: DiagramTileNode };

/** The builder lines have route handles and a label that the user moves. */
export const EDGE_TYPES = { arrow: DiagramLineEdge };
